<div class="po-wrapper">
  <router-outlet></router-outlet>
  @if (loading) {
    <div>
      <po-loading-overlay [p-text]="literals?.str0876"></po-loading-overlay>
    </div>
  }
</div>
